import castGraphQLObject from './castGraphQLObject';

export default function castForUpdate(obj: any) {
  return castGraphQLObject(obj, true);
}
